import {
  RECEIVED_OCP_DATA, RESET_OMNI_CHANNEL_PROMPT_INFO, OCP_PROMPT_CLICKED,
} from '../commonActionTypes';

const initialState = {
  omniIntents: [],
  isOmniChannelPromptEnabled: false,
  hideOmniChannelPrompt: true,
  ocpPromptClicked: false,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case RECEIVED_OCP_DATA:
      return {
        ...state,
        omniIntents: action.payload.intents,
        isOmniChannelPromptEnabled: action.payload.isOmniChannelPromptEnabled,
        hideOmniChannelPrompt: false,
        ocpPromptClicked: false,
      };
    case RESET_OMNI_CHANNEL_PROMPT_INFO:
      return {
        ...state,
        omniIntents: [],
        isOmniChannelPromptEnabled: false,
        hideOmniChannelPrompt: true,
        ocpPromptClicked: false,
      };
    case OCP_PROMPT_CLICKED:
      return {
        ...state,
        ocpPromptClicked: true,
      };
    default:
      return state;
  }
}
